import * as React from 'react';

const breakpoints = {
  tablet: '(min-width: 45rem)',
  desktop: '(min-width: 70.25rem)',
};

type Breakpoint = keyof typeof breakpoints;

export const useMediaQuery = (breakpoint: Breakpoint) => {
  const [value, setValue] = React.useState(false);

  React.useLayoutEffect(() => {
    const onChange = (event: MediaQueryListEvent) => {
      setValue(event.matches);
    };

    const query = breakpoints[breakpoint];
    const result = matchMedia(query);
    result.addEventListener('change', onChange);
    setValue(result.matches);

    return () => result.removeEventListener('change', onChange);
  }, [breakpoint]);

  return value;
};
